import {axiosInstance} from "@/app/api";
import {
  calcTime,
  convertMTOKM,
  formatDateTime,
  formatTimeFromMs,
  msToReadableTime
} from "@/libs/helper";

// Route plan name crud operations

const getRoutePlans = async () => {
  return await axiosInstance()
    .get(`/api/routePlans/list`)
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        return neoresponse.data.reportData as RoutePlan[];
      } else {
        return [] as RoutePlan[];
      }
    });
};
const addEditPlanName = async (data: any, planId: number | null) => {
  if (planId) {
    data.id = planId;
    return await axiosInstance().post(`/api/routePlans/rename`, data);
  } else {
    return await axiosInstance().post(`/api/routePlans/add`, data);
  }
};

const deletePlanName = async (planId: number) => {
  return await axiosInstance().post(`/api/routePlans/delete`, {id: planId});
};

const checkCredits = async (data: FormData) => {
  return await axiosInstance().post(`/api/routePlans/checkCredits`, data, {
    headers: {"Content-Type": "multipart/form-data"}
  });
};
// Route Plan Input parameter crud operations
const addEditRoutePlanInputs = async (data: FormData) => {
  // console.log(data.get("id"));
  // if (data.get("id")) {
  //   return await axiosInstance().post(`/api/routePlans/variant/edit`, data, {
  //     headers: {"Content-Type": "multipart/form-data"}
  //   });
  // }
  return await axiosInstance().post(`/api/routePlans/variant/add`, data, {
    headers: {"Content-Type": "multipart/form-data"}
  });
};

const getRoutePlanInputs = async (planId: any) => {
  return await axiosInstance()
    .post(`/api/routePlans/variant/list`, {planId: planId})
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        return neoresponse.data.reportData as RoutePlanInputHistory[];
      } else {
        return [] as RoutePlanInputHistory[];
      }
    });
};

const setAsDefaultRoutePlan = async (
  inputParamId: string,
  planId: string | number
) => {
  return await axiosInstance().post(`/api/routePlans/variant/setCurrent`, {
    variantId: inputParamId,
    planId: planId
  });
};

const deletePlanHistory = async (
  inputParamId: string,
  planId: string | number
) => {
  return await axiosInstance().post(`/api/routePlans/variant/delete`, {
    variantId: inputParamId,
    planId: planId
  });
};
const getRoutePlanOutput = async (variantId: any) => {
  return await axiosInstance()
    .post(`/api/routePlans/variant/readById`, {variantId: variantId})
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        return neoresponse.data as RoutePlanVariant;
      } else {
        return null as RoutePlanVariant | null;
      }
    });
};

const onGetrouteInfo = async (routeId: number, colorCode: string) => {
  return await axiosInstance()
    .post(`/api/routePlans/routeInfo`, {routeId: routeId, colorCode: colorCode})
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        return neoresponse.data as RouteData_RP;
      } else {
        return null as RouteData_RP | null;
      }
    });
};

const onUnmappedUsersList = async (req: any) => {
  return await axiosInstance()
    .post(`/api/routePlans/available/studentList`, req)
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        return neoresponse.data;
      } else {
        return null;
      }
    });
};

const mapUnmapUsers = async (data: any) => {
  return await axiosInstance()
    .post(`/api/routePlans/bpUsersMapping`, data)
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        // console.log("onGetrouteInfo response", neoresponse);
        //  return neoresponse.data;
        return neoresponse;
      } else {
        return null;
      }
    });
};

const bpOperations = async (data: any) => {
  return await axiosInstance()
    .post(`/api/routePlans/bpOperations`, data)
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        return neoresponse;
      } else {
        return null;
      }
    });
};

const routeHistory = async (variantId: number) => {
  return await axiosInstance()
    .post("/api/routeChange/history", {variantId: variantId})
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        if (neoresponse.data.routehistoriesList) {
          const routehistoriesList = neoresponse.data.routehistoriesList;
          const history: routeHistory_RP[] = routehistoriesList.map(
            (hist: any) => {
              const prevTotalDistance = hist.prevTotalDistance;
              const currentTotalDistance = hist.currentTotalDistance;

              const prevTotalDuration = hist.prevTotalDuration;
              const currentTotalDuration = hist.currentTotalDuration;

              const currentTotalUsers = hist.currentTotalUsers;
              const prevTotalUsers = hist.prevTotalUsers;
              return {
                id: hist.routeId,
                vehicleName: hist.regNumber,
                mappedUserCount: currentTotalUsers,
                prevMappedUserCount: prevTotalUsers,
                usersColor: "bg-green-100 text-green-600", // e.g. "bg-green-100 text-green-600"
                routeName: hist.routeName, // e.g. "R1_M_T01"
                prevTotalDistance: convertMTOKM(prevTotalDistance),
                distance: ` ${convertMTOKM(currentTotalDistance)}`, // e.g. "15.13km"
                distanceColor:
                  prevTotalDistance > currentTotalDistance
                    ? "text-green-600"
                    : "text-red-600", // e.g. "text-green-600"
                time: currentTotalDuration, // e.g. "08:14 - 09:14"
                preTravelTime: msToReadableTime(prevTotalDuration),
                travel: msToReadableTime(currentTotalDuration),
                travelColor:
                  prevTotalDuration > currentTotalDuration
                    ? "text-green-600"
                    : "text-red-600" // e.g. "text-red-600"
              };
            }
          );
          return history;
        } else {
          return null;
        }
      } else {
        return null;
      }
    });
};

type OutputRouteListSummary = {
  pickup: {
    routes: number;
    boardingPoints: number;
    studentMapped: number;
  };
  drop: {
    routes: number;
    boardingPoints: number;
    studentMapped: number;
  };
  routeEfficiency: {
    routeDistanceEfficiency: {
      source: string;
      parsedValue: number;
    };
    avgTimeEfficiency: number;
  };
};
// Active Routes API's Start Below
const onGetActiveRoutes = async () => {
  return await axiosInstance()
    .get(`/api/routes/list`)
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        var endPointData = neoresponse?.data?.reportData;

        const rows = endPointData.map((row: any) => ({
          ...row,
          id: row.userId
        }));
        const summary = neoresponse?.data?.summary;
        const statisticsData: OutputRouteListSummary | null = summary;

        const summaryResult = [
          {
            id: 2,
            title: "Pickup Routes",
            subTitle: "Morning transportation",
            value: statisticsData?.pickup.routes ?? 0,
            icon: "pickupBus",
            bg: "bg-green-100",
            subCard: [
              {
                title: "Boarding Points",
                value: statisticsData?.pickup.boardingPoints ?? 0
              },
              {
                title: "Users Mapped",
                value: statisticsData?.pickup.studentMapped ?? 0
              }
            ]
          },
          {
            id: 3,
            title: "Drop Routes",
            subTitle: "Afternoon/Evening transportation",
            value: statisticsData?.drop.routes ?? 0,
            icon: "dropBus",
            bg: "bg-orange-100",
            subCard: [
              {
                title: "Boarding Points",
                value: statisticsData?.drop.boardingPoints ?? 0
              },
              {
                title: "Users Mapped",
                value: statisticsData?.drop.studentMapped ?? 0
              }
            ]
          },
          {
            id: 4,
            title: "Route Efficiency",
            subTitle: "Performance metrics",
            value: 0,
            icon: "routeEfficincy",
            bg: "bg-blue-100",
            subCard: [
              {
                title: "Avg Route Distance",
                value:
                  convertMTOKM(
                    statisticsData?.routeEfficiency.routeDistanceEfficiency
                  ) ?? 0
              },
              {
                title: "Avg Duration",
                value: statisticsData?.routeEfficiency.avgTimeEfficiency
                  ? (formatTimeFromMs(
                      statisticsData?.routeEfficiency.avgTimeEfficiency *
                        60 *
                        1000
                    ) ?? 0)
                  : 0
              }
            ]
          }
        ];
        return {
          columns: neoresponse?.data?.columns,
          headerData: neoresponse?.data?.timeData
            ? neoresponse?.data?.timeData
            : [],
          statistics: summaryResult,
          rows: rows,
          meta: neoresponse?.meta
        } as TableResponse<any>;
      } else {
        return null;
      }
    });
};

type ActivityItem = {
  id: string;
  type: string;
  title: string;
  subtitle: string;
  // time: string;
  // user: string;
  credits: number;
};
type Summary = {
  usageBreakDowns: {
    name: string;
    usage: number;
  }[];
  creditOverview: {
    usedCredits: number;
    remaining: number;
  };
};
const getCreditOverview = async (req: {from: number; to: number}) => {
  return await axiosInstance()
    .post(`/api/routePlans/credit/overview`, req)
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        // console.log("onGetrouteInfo response", neoresponse);
        //  return neoresponse.data;
        const summary = {
          usageBreakDowns: [
            {
              name: "Vahan Fetch",
              usage: 0
            },
            {
              name: "Route Plan",
              usage: 0
            }
          ],
          creditOverview: {
            usedCredits: 0,
            remaining: 0
          }
        };
        const res = {
          reportData: [] as ActivityItem[],
          summary: summary as Summary,
          reportDataDownload: []
        };
        if (
          neoresponse?.data?.reportData &&
          neoresponse?.data?.reportData.length > 0
        ) {
          const reportDatares: ActivityItem[] =
            neoresponse?.data?.reportData.map((item: any) => ({
              // id: item.id,
              type: item.type === 1 ? "Vahan Fetch" : "Route Plan",
              title: item.description,
              subtitle: `${calcTime(item.createdDt)} . ${item.updatedBy}`,
              // time: item.createdDt,
              credits: item.credits
              //user: item.updatedBy
            }));
          const reportDataDownload = neoresponse?.data?.reportData.map(
            (item: any) => ({
              // ...item,
              // createdDt: calcTime(item.createdDt),
              // type: item.type === 1 ? "Vahan Fetch" : "Route Plan"
              Name: item.name,
              Type: item.type === 1 ? "Vahan Fetch" : "Route Plan",
              Credits: item.credits,
              Description: item.description,
              "Created At": formatDateTime(item.createdDt),
              "Updated By": item.updatedBy
            })
          );
          res.reportDataDownload = reportDataDownload;
          summary.usageBreakDowns = neoresponse?.data.summary.usageBreakDowns;
          summary.creditOverview = neoresponse?.data.summary.creditOverview;
          res.reportData = reportDatares;
          //return neoresponse.data as CreditOverview;
        }
        return res;
      } else {
        return null;
      }
    });
};

const updateCreditCoin = async () => {
  return await axiosInstance()
    .get(`/api/credits/request`)
    .then((response: any) => {
      if (response.data.status === "success") {
        const neoresponse: NeoResponse<any> = response.data;
        return neoresponse;
      } else {
        return null;
      }
    });
};
// Active Routes API's End Above
export const routePlanService = {
  getRoutePlans,
  addEditPlanName,
  deletePlanName,
  checkCredits,
  addEditRoutePlanInputs, //Input parameters API
  getRoutePlanInputs, //input reports
  setAsDefaultRoutePlan,
  deletePlanHistory,
  getRoutePlanOutput, // Get Output API
  onGetrouteInfo, // Get route info API
  onUnmappedUsersList, // Unmapped users list API
  mapUnmapUsers,
  bpOperations,
  routeHistory
};

export const creaditOverview = {
  getCreditOverview,
  updateCreditCoin
};
export const activeRoute = {
  onGetActiveRoutes
};
